module.exports = __webpack_public_path__ + "img/user-menu-api.b91ca6c5.svg";